const _m = {
	
	'specMap': {
		"38": {"specialty": "Allergy & Clinical Immunology", "specialist": "Allergists", "jobUrl": "/allergy-and-clinical-immunology"},
		"46": {"specialty": "Anesthesiology", "specialist": "Anesthesiologists", "jobUrl": "/anesthesiology"},
		"2": {"specialty": "Cardiology", "specialist": "Cardiologists", "jobUrl": "/cardiology"},
		"32": {"specialty": "Critical Care", "specialist": "Critical Care Specialists", "jobUrl": "/critical-care"},
		"33": {"specialty": "Dermatology", "specialist": "Dermatologists", "jobUrl": "/dermatology"},
		"22": {"specialty": "Diabetes & Endocrinology", "specialist": "Diabetologists & Endocrinologists", "jobUrl": "/diabetes-and-endocrinology"},
		"45": {"specialty": "Emergency Medicine", "specialist": "Emergency Medicine Physicians", "jobUrl": "/emergency-medicine"},
		"34": {"specialty": "Primary Care", "specialist": "Primary Care Physicians", "jobUrl": "/family-medicine-primary-care"},
		"20": {"specialty": "Gastroenterology", "specialist": "Gastroenterologists", "jobUrl": "/gastroenterology"},
		"14": {"specialty": "General Surgery", "specialist": "Surgeons", "jobUrl": "/general-surgery"},
		"3": {"specialty": "HIV/Infectious Diseases", "specialist": "Infectious Disease Specialists", "jobUrl": "/infectious-diseases"},
		"18": {"specialty": "Internal Medicine", "specialist": "Internists", "jobUrl": "/internal-medicine"},
		"17": {"specialty": "Multispecialty", "specialist": "Physicians", "jobUrl": "/multispecialty"},
		"44": {"specialty": "Nephrology", "specialist": "Nephrologists", "jobUrl": "/nephrology"},
		"26": {"specialty": "Neurology", "specialist": "Neurologists", "jobUrl": "/neurology"},
		"16": {"specialty": "Ob/Gyn & Women's Health", "specialist": "Obstetricians & Gynecologists", "jobUrl": "/ob-gyn-and-women-s-health"},
		"7": {"specialty": "Oncology", "specialist": "Oncologists", "jobUrl": "/oncology"},
		"36": {"specialty": "Ophthalmology", "specialist": "Ophthalmologists", "jobUrl": "/ophthalmology"},
		"8": {"specialty": "Orthopedics", "specialist": "Orthopedic Surgeons", "jobUrl": "/orthopedics"},
		"43": {"specialty": "Pathology & Lab Medicine", "specialist": "Pathologists", "jobUrl": "/pathology-and-lab-medicine"},
		"9": {"specialty": "Pediatrics", "specialist": "Pediatricians", "jobUrl": "/pediatrics"},
		"48": {"specialty": "Plastic Surgery & Aesthetic Medicine", "specialist": "Plastic Surgeons", "jobUrl": "/plastic-surgery-and-aesthetic-medicine"},
		"12": {"specialty": "Psychiatry", "specialist": "Psychiatrists", "jobUrl": "/psychiatry"},
		"42": {"specialty": "Public Health & Prevention", "specialist": "Public Health Specialists", "jobUrl": "/public-health-and-prevention"},
		"13": {"specialty": "Pulmonary Medicine", "specialist": "Pulmonologists", "jobUrl": "/pulmonary-medicine"},
		"35": {"specialty": "Radiology", "specialist": "Radiologists", "jobUrl": "/radiology"},
		"27": {"specialty": "Rheumatology", "specialist": "Rheumatologists", "jobUrl": "/rheumatology"},
		"15": {"specialty": "Urology", "specialist": "Urologists", "jobUrl": "/urology"}
	},
	
	'stateName': {
		'AL': 'Alabama',
		'AK': 'Alaska',
		'AZ': 'Arizona',
		'AR': 'Arkansas',
		'CA': 'California',
		'CO': 'Colorado',
		'CT': 'Connecticut',
		'DE': 'Delaware',
		'DC': 'District of Columbia',
		'FL': 'Florida',
		'GA': 'Georgia',
		'HI': 'Hawaii',
		'ID': 'Idaho',
		'IL': 'Illinois',
		'IN': 'Indiana',
		'IA': 'Iowa',
		'KS': 'Kansas',
		'KY': 'Kentucky',
		'LA': 'Louisiana',
		'ME': 'Maine',
		'MD': 'Maryland',
		'MA': 'Massachusetts',
		'MI': 'Michigan',
		'MN': 'Minnesota',
		'MS': 'Mississippi',
		'MO': 'Missouri',
		'MT': 'Montana',
		'NE': 'Nebraska',
		'NV': 'Nevada',
		'NH': 'New Hampshire',
		'NJ': 'New Jersey',
		'NM': 'New Mexico',
		'NY': 'New York',
		'NC': 'North Carolina',
		'ND': 'North Dakota',
		'OH': 'Ohio',
		'OK': 'Oklahoma',
		'OR': 'Oregon',
		'PA': 'Pennsylvania',
		'RI': 'Rhode Island',
		'SC': 'South Carolina',
		'SD': 'South Dakota',
		'TN': 'Tennessee',
		'TX': 'Texas',
		'UT': 'Utah',
		'VT': 'Vermont',
		'VA': 'Virginia',
		'WA': 'Washington',
		'WV': 'West Virginia',
		'WI': 'Wisconsin',
		'WY': 'Wyoming'
	}
	
}

export default _m;